import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ManageorderComponent } from './manageorder.component';
import { ManageorderRoutingModule } from './manageorder-routing.module';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { MatTableModule, MatPaginatorModule, MatSortModule, MatIconModule, MatButtonModule, MatSelectModule, MatFormFieldModule, MatInputModule } from '@angular/material';



@NgModule({
    declarations: [ManageorderComponent],
    imports: [
        CommonModule,
        NgbModule,
        ManageorderRoutingModule,
        CommonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        SharedModule,
        ReactiveFormsModule,
        MatchHeightModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule,
        MatButtonModule,
        MatchHeightModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        
    ]
})
export class ManageorderModule { }

